import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { TextVideo1_Carlos } from '../../../../../utils/EN/Modals/directors';

const ModalVideoCarlos1 = () => {
  return (
    <>
      <ModalVideo
        id="carlos-video-1"
        dataText={TextVideo1_Carlos}
        videoSrc="https://player.vimeo.com/video/949992885?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_DIRECTORS_CARLOS_1"
      />
    </>
  );
};

export default ModalVideoCarlos1;
